import React from "react";
import { camelCase } from "lodash";
import "./style.scss";

import kismet from "../../assets/img/beaches/kismet.jpg";
import oceanBeach from "../../assets/img/beaches/ocean-beach.jpg";
import fiLighthouse from "../../assets/img/beaches/fiLighthouse2.jpg";
import saltaire from "../../assets/img/beaches/saltaire.jpg";
import fairHarbor from "../../assets/img/beaches/fairHarbor.jpg";
import sailorsHavenSunkenForest from "../../assets/img/beaches/sailorsHaven.jpg";
import cherryGrove from "../../assets/img/beaches/cherryGrove.jpg";
import fiPines from "../../assets/img/beaches/fiPines.jpg";

const images = {
  kismet,
  oceanBeach,
  fiLighthouse,
  saltaire,
  fairHarbor,
  sailorsHavenSunkenForest,
  cherryGrove,
  fiPines,
};

const PageHeader = ({ beach, children }) => {
  let image = kismet;
  if (
    beach &&
    images[camelCase(beach.replace(/[^\w\s]/gi, "").replace(/\s+/g, "-"))]
  ) {
    image =
      images[camelCase(beach.replace(/[^\w\s]/gi, "").replace(/\s+/g, "-"))];
  }
  return (
    <section className="page-header">
      <div
        className="inner-panel shadowed"
        style={{ backgroundImage: `url(${image})` }}
      >
        <div className="content">{children}</div>
        <div className="image-overlay" />
      </div>
    </section>
  );
};

export default PageHeader;
